import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { Trash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { DeleteJackpotModel } from '../../model';

export const createDeleteJackpotModal = (model: DeleteJackpotModel) => {
	const ConfirmModal = createConfirmModal(model);

	const DeleteJackpotModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [jackpot] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('delete-jackpot.title')}
				cancelButtonProps={{
					children: t('delete-jackpot.cancel'),
				}}
				submitButtonProps={{
					children: t('delete-jackpot.delete'),
					variant: 'destructive',
				}}
				{...props}
			>
				{t('delete-jackpot.description', {
					currency: jackpot?.currency,
					type: t(`jackpot-types.${jackpot?.type}`),
				})}
			</ConfirmModal>
		);
	});

	const DeleteJackpotModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'delete-jackpot-action-icon',
			variant: 'ghost-destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <Trash2 />,
		},
	});

	return Object.assign(DeleteJackpotModal, {
		ActionIcon: DeleteJackpotModalActionIcon,
	});
};
